(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    class AcceleratedCheckoutToCart extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = async (event) => {
      const button = event.target.closest('[data-go-to-cart-after-add]');
      if (!button) return;

      const form = this.closest('form');
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: new FormData(form),
        });

        if (!response.ok) throw new Error('Failed to add item to cart');

        window.location.href = Theme.routes.cart_url || '/cart';
      } catch (error) {
        console.error(error);
        button.disabled = false;
        button.removeAttribute('aria-busy');
        window.alert('カートへの移動に失敗しました。「カートに入れる」ボタンをご利用ください。');
      }
    };
  }

  if (!customElements.get('accelerated-checkout-to-cart')) {
    customElements.define('accelerated-checkout-to-cart', AcceleratedCheckoutToCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    if (!window.__chilaiMemberSignupInit) {
    window.__chilaiMemberSignupInit = true;

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target.closest('form');
        if (!form) return;

        const context = form.closest('[data-member-signup-form="true"]');
        if (!context) return;

        const emailInput = form.querySelector('input[name="contact[email]"]');
        if (!emailInput) return;

        const email = emailInput.value.trim().toLowerCase();
        if (!email) return;

        window.sessionStorage.setItem('chilai-member-signup-email', email);
      },
      true
    );

    const successContext = document.querySelector('[data-member-signup-form="true"]');
    const successForm = successContext?.querySelector('form');
    const successMessage = successContext?.querySelector('[id^="Email-signup__message-success-"]');
    if (successContext && successForm && successMessage) {
      const pendingEmail = window.sessionStorage.getItem('chilai-member-signup-email');
      if (pendingEmail) {
        window.localStorage.setItem('chilai-member-preview-email', pendingEmail);
        window.sessionStorage.removeItem('chilai-member-signup-email');
      } else {
        window.localStorage.setItem('chilai-member-preview-email', 'member');
      }

      const thankYouPath = successContext.dataset.thankYouPath;
      if (thankYouPath) {
        window.location.assign(thankYouPath);
      }
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-page-content"] && !Shopify.designMode) return;
  try {
    class FaqPageComponent extends HTMLElement {
    #controller = new AbortController();
    #scrollFrame = null;
    #storageKey = 'chilai-registration-audience';

    connectedCallback() {
      const { signal } = this.#controller;
      const summaries = this.querySelectorAll('accordion-custom[data-animate="true"] > details > summary');
      const initialAudience = this.#getStoredAudience() || this.dataset.registrationAudience || 'standard';

      this.#buildNav();
      this.#bindRegistrationTabs(signal);
      this.#setRegistrationAudience(initialAudience);

      summaries.forEach((summary) => {
        summary.addEventListener('click', this.#handleSummaryClick, { signal });
      });

      this.querySelectorAll('.faq-page__nav-link[href^="#"]').forEach((link) => {
        link.addEventListener('click', this.#handleNavClick, { signal });
      });

      window.addEventListener('scroll', this.#handleViewportChange, { passive: true, signal });
      window.addEventListener('resize', this.#handleViewportChange, { passive: true, signal });
      document.addEventListener('shopify:section:select', this.#handleThemeEditorSectionSelect, { signal });
      document.addEventListener('shopify:section:load', this.#handleThemeEditorSectionLoad, { signal });

      this.#updateActiveNavLink();
    }

    disconnectedCallback() {
      this.#controller.abort();
      if (this.#scrollFrame !== null) {
        window.cancelAnimationFrame(this.#scrollFrame);
      }
    }

    #handleNavClick = (event) => {
      const link = event.currentTarget;

      if (!(link instanceof HTMLAnchorElement)) return;

      this.#setActiveNavLink(link.getAttribute('href'));
    };

    #handleViewportChange = () => {
      if (this.#scrollFrame !== null) return;

      this.#scrollFrame = window.requestAnimationFrame(() => {
        this.#scrollFrame = null;
        this.#updateActiveNavLink();
      });
    };

    #bindRegistrationTabs(signal) {
      const tabs = Array.from(this.querySelectorAll('.registration-tabs__tab[data-registration-tab]'));

      if (tabs.length === 0) return;

      tabs.forEach((tab) => {
        tab.addEventListener(
          'click',
          () => {
            const audience = tab.getAttribute('data-registration-tab') || 'standard';
            this.#setRegistrationAudience(audience);
          },
          { signal }
        );
      });
    }

    #setRegistrationAudience(audience) {
      this.dataset.registrationAudience = audience;
      this.#storeAudience(audience);
      this.#syncRegistrationTabs(audience);
      this.#syncRegistrationPanels(audience);
    }

    #syncRegistrationTabs(audience) {
      this.querySelectorAll('.registration-tabs__tab[data-registration-tab]').forEach((tab) => {
        const isActive = tab.getAttribute('data-registration-tab') === audience;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    #syncRegistrationPanels(audience) {
      document.querySelectorAll('[data-registration-tab-panel]').forEach((panel) => {
        if (!(panel instanceof HTMLElement)) return;

        const targetAudience = panel.getAttribute('data-registration-tab-panel') || 'all';
        const isHidden = targetAudience !== 'all' && targetAudience !== audience;
        const sectionWrapper = panel.closest('.shopify-section');

        panel.hidden = isHidden;

        if (sectionWrapper instanceof HTMLElement) {
          sectionWrapper.hidden = isHidden;
        }
      });
    }

    #handleThemeEditorSectionSelect = (event) => {
      const target = event.target;

      if (!(target instanceof HTMLElement)) return;

      const panel = target.matches('[data-registration-tab-panel]')
        ? target
        : target.querySelector('[data-registration-tab-panel]');

      if (!(panel instanceof HTMLElement)) return;

      const audience = panel.getAttribute('data-registration-tab-panel');

      if (audience === 'standard' || audience === 'business') {
        this.#setRegistrationAudience(audience);
      }
    };

    #handleThemeEditorSectionLoad = () => {
      this.#syncRegistrationPanels(this.dataset.registrationAudience || this.#getStoredAudience() || 'standard');
    };

    #getStoredAudience() {
      try {
        const audience = window.sessionStorage.getItem(this.#storageKey);
        return audience === 'standard' || audience === 'business' ? audience : '';
      } catch (error) {
        return '';
      }
    }

    #storeAudience(audience) {
      try {
        window.sessionStorage.setItem(this.#storageKey, audience);
      } catch (error) {
      }
    }

    #buildNav() {
      const navList = this.querySelector('.faq-page__nav-list');
      const groups = Array.from(this.querySelectorAll('.faq-group[id]'));

      if (!(navList instanceof HTMLElement)) return;

      navList.innerHTML = '';

      groups.forEach((group) => {
        if (!(group instanceof HTMLElement) || !group.id) return;

        const label =
          group.dataset.navLabel?.trim() || group.querySelector('.faq-group__heading')?.textContent?.trim() || '';

        if (!label) return;

        const item = document.createElement('li');
        item.className = 'faq-page__nav-item';

        const link = document.createElement('a');
        link.className = 'faq-page__nav-link';
        link.href = `#${group.id}`;
        link.textContent = label;

        item.appendChild(link);
        navList.appendChild(item);
      });

      if (navList.childElementCount === 0) {
        this.querySelector('.faq-page__nav')?.setAttribute('hidden', 'true');
      } else {
        this.querySelector('.faq-page__nav')?.removeAttribute('hidden');
      }
    }

    #updateActiveNavLink() {
      const groups = Array.from(this.querySelectorAll('.faq-group[id]'));

      if (groups.length === 0) return;

      const pageBottom = window.scrollY + window.innerHeight;
      const documentBottom = document.documentElement.scrollHeight;

      if (documentBottom - pageBottom <= 8) {
        const lastGroup = groups[groups.length - 1];

        if (lastGroup instanceof HTMLElement) {
          this.#setActiveNavLink(`#${lastGroup.id}`);
        }

        return;
      }

      const headerOffset = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 60;
      const triggerY = headerOffset + 40;

      let currentGroup = groups[0];

      groups.forEach((group) => {
        if (!(group instanceof HTMLElement)) return;

        if (group.getBoundingClientRect().top <= triggerY) {
          currentGroup = group;
        }
      });

      this.#setActiveNavLink(`#${currentGroup.id}`);
    }

    #setActiveNavLink(targetId) {
      const navLinks = this.querySelectorAll('.faq-page__nav-link[href^="#"]');

      navLinks.forEach((link) => {
        const isActive = link.getAttribute('href') === targetId;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    #handleSummaryClick = (event) => {
      const summary = event.currentTarget;

      if (!(summary instanceof HTMLElement)) return;

      const details = summary.closest('details');
      const accordion = summary.closest('accordion-custom');

      if (!(details instanceof HTMLDetailsElement) || !(accordion instanceof HTMLElement)) return;
      if (accordion.dataset.hasContent !== 'true') {
        event.preventDefault();
        return;
      }
      if (details.dataset.animStatus === 'running') {
        event.preventDefault();
        return;
      }

      const content = details.querySelector('.details-content');

      if (!(content instanceof HTMLElement)) return;

      event.preventDefault();

      if (details.open) {
        this.#close(details, content);
        return;
      }

      this.#open(details, content);
    };

    #open(details, content) {
      details.dataset.animStatus = 'running';
      details.setAttribute('open', 'true');

      const endHeight = `${content.scrollHeight}px`;
      const animation = this.#animate(content, [
        { blockSize: '0px', opacity: 0 },
        { blockSize: endHeight, opacity: 1 },
      ]);

      animation.onfinish = () => {
        details.dataset.animStatus = '';
        content.style.overflow = '';
        content.style.blockSize = '';
        content.style.opacity = '';
      };
    }

    #close(details, content) {
      details.dataset.animStatus = 'running';

      const startHeight = `${content.offsetHeight}px`;
      const animation = this.#animate(content, [
        { blockSize: startHeight, opacity: 1 },
        { blockSize: '0px', opacity: 0 },
      ]);

      animation.onfinish = () => {
        details.dataset.animStatus = '';
        details.removeAttribute('open');
        content.style.overflow = '';
        content.style.blockSize = '';
        content.style.opacity = '';
      };
    }

    #animate(content, keyframes) {
      content.style.overflow = 'hidden';

      return content.animate(keyframes, {
        duration: 280,
        easing: 'ease',
        fill: 'forwards',
      });
    }
  }

  if (!customElements.get('faq-page-component')) {
    customElements.define('faq-page-component', FaqPageComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["preorder-check-content"] && !Shopify.designMode) return;
  try {
    class PreorderCheckComponent extends HTMLElement {
    connectedCallback() {
      if (this.dataset.designMode === 'true') return;
      if (this.dataset.state !== 'ready') return;

      this.#syncReservedItems();
    }

    async #syncReservedItems() {
      const items = this.#getReservedItems();

      if (!items.length) return;

      this.classList.add('is-loading');
      this.#setStatus('予約済み商品をカートへ反映しています。');

      try {
        const cart = await this.#requestJson(this.dataset.cartUrl || '/cart.js', {
          headers: {
            Accept: 'application/json',
          },
        });

        const currentQuantities = new Map();

        for (const item of cart.items || []) {
          const variantId = String(item.variant_id);
          const existingQuantity = currentQuantities.get(variantId) || 0;
          currentQuantities.set(variantId, existingQuantity + Number(item.quantity || 0));
        }

        const additions = items
          .map((item) => {
            const currentQuantity = currentQuantities.get(String(item.variantId)) || 0;
            const quantityToAdd = Math.max(item.quantity - currentQuantity, 0);

            if (quantityToAdd < 1) return null;

            return {
              id: item.variantId,
              quantity: quantityToAdd,
            };
          })
          .filter(Boolean);

        if (additions.length > 0) {
          await this.#requestJson(this.dataset.addUrl || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: additions }),
          });

          this.#setStatus('予約済み商品をカートへ追加しました。移動します。');
        } else {
          this.#setStatus('予約済み商品はすでにカートへ反映されています。移動します。');
        }

        window.setTimeout(() => {
          window.location.assign(this.dataset.redirectUrl || '/cart');
        }, 250);
      } catch (error) {
        console.error('Preorder cart sync failed', error);
        this.classList.remove('is-loading');
        this.dataset.state = 'error';
        this.#setStatus(this.dataset.errorMessage || '予約商品の反映に失敗しました。');
      }
    }

    #getReservedItems() {
      return Array.from(this.querySelectorAll('.preorder-check__item'))
        .map((item) => {
          const variantId = Number(item.dataset.variantId || 0);
          const quantity = Number(item.dataset.quantity || 0);

          if (!variantId || quantity < 1) return null;

          return {
            variantId,
            quantity,
          };
        })
        .filter(Boolean);
    }

    async #requestJson(url, options = {}) {
      const response = await fetch(url, options);

      if (!response.ok) {
        let message = `${response.status} ${response.statusText}`;

        try {
          const body = await response.json();
          if (body?.description) {
            message = body.description;
          }
        } catch (_error) {
          // noop
        }

        throw new Error(message);
      }

      return response.json();
    }

    #setStatus(message) {
      const statusElement = this.querySelector('[data-status]');
      if (!(statusElement instanceof HTMLElement)) return;
      statusElement.textContent = message;
    }
  }

  if (!customElements.get('preorder-check-component')) {
    customElements.define('preorder-check-component', PreorderCheckComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
